import CustomViewType from "@/domain/enums/CustomViewType";
import EmailDisplayMode from "@/domain/enums/EmailDisplayMode";
import ViewFilter from "./ViewFilter";
import ViewWidgetSettings from "./ViewWidgetSettings";

export type CustomViewInput = {
    id?: string;
    userId: string;
    name: string;
    icon: string;
    filters: ViewFilter;
    displayMode: EmailDisplayMode;
    widgets: ViewWidgetSettings;
    userPrompt: string;
    noteContent: string;
    internetMessageIds: string[];
};

type CustomViewProps = {
    id?: string;
    userId: string;
    name: string;
    icon: string;
    filters: ViewFilter;
    displayMode: EmailDisplayMode;
    widgets: ViewWidgetSettings;
    createdAt: Date;
    updatedAt: Date;
    isFavorite: boolean;
    displayOrder: number;
    userPrompt: string;
    noteContent: string;
    internetMessageIds: string[];
};

export default class CustomView {
    id?: string;

    userId: string;

    name: string;

    viewType: CustomViewType;

    icon: string;

    filters: ViewFilter;

    displayMode: EmailDisplayMode;

    widgets: ViewWidgetSettings;

    createdAt: Date;

    updatedAt: Date;

    isFavorite: boolean;

    displayOrder: number;

    userPrompt: string;

    noteContent: string;

    internetMessageIds: string[];

    constructor({
        id,
        userId,
        name,
        icon,
        filters,
        displayMode,
        widgets,
        createdAt,
        updatedAt,
        isFavorite,
        displayOrder,
        userPrompt,
        noteContent,
        internetMessageIds,
    }: CustomViewProps) {
        this.id = id;
        this.userId = userId;
        this.name = name;
        this.icon = icon;
        this.filters = filters;
        this.displayMode = displayMode;
        this.widgets = widgets;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.isFavorite = isFavorite;
        this.displayOrder = displayOrder;
        this.userPrompt = userPrompt;
        this.noteContent = noteContent;
        this.internetMessageIds = internetMessageIds;
    }

    setIsFavorite(isFavorite: boolean) {
        this.isFavorite = isFavorite;
    }

    setNoteContent(noteContent: string) {
        this.noteContent = noteContent;
    }
}
